import React from 'react';
import PropTypes from 'prop-types';

const TrendDown01Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="9"
    viewBox="0 0 16 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.59998 1.29995L5.18398 4.74611L8.25597 1.79226L14.4 7.69995M14.4 7.69995H9.79198M14.4 7.69995V3.26918"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

TrendDown01Icon.propTypes = {
  color: PropTypes.string,
};

export default TrendDown01Icon;
